<div class="input-component"
     [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
    <div class="input-global">
        <div class="input-wrapper">
            <input [disabled]="notEnabled"
                   type="text"
                   class="input-field"
                   [attr.required]="required"
                   [(ngModel)]="value"
                   [id]="fieldId"
                   [name]="name"
                   [attr.value]="value"
                   [ngModelOptions]="updateOn" />
            <label [attr.for]="fieldId">{{label}}</label>
            <span class="input-validation fa-stack fa-1x"
                  *ngIf="dirty">
                <i class="fas fa-stack-2x fa-circle"
                   aria-hidden="true">
                </i>
                <i class="fal fa-stack-1x"
                   [ngClass]="(validStatus$ | async) ? 'fa-check' : 'fa-times'"
                   aria-hidden="true">
                </i>
            </span>
        </div>
        <div class="copy">
            <span class="fa-stack fa-1x"
                  title="{{ titleKey | uppercase | translate }}"
                  (click)="onCopy(value)">
                <i class="fas fa-circle fa-stack-2x"
                   aria-hidden="true">
                </i>
                <i class="fas fa-copy fa-stack-1x"
                   aria-hidden="true">
                </i>
            </span>
        </div>
    </div>
    <aa-validation2 [dirty]="dirty"
                    [messages]="failures | async">
    </aa-validation2>
</div>
